<template>
  <div>
    <v-form
      ref="form"
      class="mx-2"
      lazy-validation
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-combobox
            v-model="localData.memberModel"
            clearable
            required
            :items="members"
            label="عضو*"
            single-line
            return-object
            :error-messages="errorMessages"
            item-text="fullName"
            item-value="id"
            :rules="[() => !!localData.memberModel || 'عضو را انتخاب کنید']"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localData.loanModel"
            clearable
            required
            single-line
            return-object
            :items="loans"
            label="وام*"
            item-text="title"
            item-value="id"
            :error-messages="errorMessages"
            :rules="[() => !!localData.loanModel || 'وام را انتخاب کنید']"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-money
            ref="amount"
            v-model="localData.amount"
            label="مبلغ*"
            :error-messages="errorMessages"
            :rules="[
              () =>
                localData.amount > 0 || 'مبلغ وام را به صورت صحیح وارد کنید',
            ]"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-money
            ref="installment"
            v-model="localData.installment"
            label="مبلغ هر قسط*"
            :error-messages="errorMessages"
            :rules="[
              () =>
                !!localData.installment > 0 ||
                'مبلغ هر قسط را به صورت صحیح وارد کنید',
            ]"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="month"
            v-model="localData.month"
            label="تعداد اقساط*"
            :error-messages="errorMessages"
            :rules="[
              () =>
                Number(localData.month) > 0 ||
                'تعداد اقساط را به صورت صحیح وارد کنید',
            ]"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <div>
            <div>شروع اقساط</div>
            <date-picker
              ref="startDate"
              v-model="localData.startDate"
              format="YYYY-MM-DDTHH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY"
              :error-messages="errorMessages"
              auto-submit
              :rules="[
                () =>
                  !!localData.startDate ||
                  'تاریخ شروع را به صورت صحیح وارد کنید',
              ]"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-checkbox
            v-model="localData.isCheckouted"
            label="وام تسویه شده"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <div>
            <div>تاریخ تسویه</div>
            <date-picker
              ref="checkoutDate"
              v-model="localData.checkoutDate"
              format="YYYY-MM-DDTHH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY"
              :error-messages="errorMessages"
              auto-submit
            />
          </div>
        </v-col>
      </v-row>
      <small>*فیلدهای ستاره دار ضروری هستند.</small>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('callbck', false)">
        بستن
      </v-btn>
      <v-btn
        color="blue"
        dark
        :loading="submitLoading"
        @click="submit()"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import { emptyId } from '@/util/emptyId'
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  export default {
    name: 'LoanInstallmentsView',
    components: {
      'date-picker': VuePersianDatetimePicker,
    },
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        loans: [],
        members: [],
        submitLoading: false,
      }
    },
    mounted () {
      this.prepareData()
    },
    methods: {
      submit () {
        if (!this.$refs.form.validate()) {
          return
        }
        // this.localData.startDate = this.localData.startDate.replace(' ', 'T')
        this.submitLoading = true
        api
          .post(
            'admin/userloan/' +
              (this.localData.id === emptyId ? 'create' : 'edit'),
            this.localData,
          )
          .then((response) => {
            toast.success('اطلاعات با موفقیت ذخیره شد.')
            this.$emit('callbck', true)
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.submitLoading = false
          })
      },
      prepareData () {
        if (!this.data) {
          this.data = { id: emptyId }
        }
        api
          .get('admin/userloan/get/' + this.data.id, null)
          .then((response) => {
            this.localData = response
            if (!this.data.memberModel || this.localData.id !== emptyId) {
              this.loadMembers()
            } else {
              this.members = [this.data.memberModel]
              this.localData.memberModel = this.data.memberModel
            }
          })
          .catch((err) => {
            toast.error(err.message)
          })

        this.loadLoans()
      },
      loadLoans () {
        api
          .get('admin/loan/list', null)
          .then((response) => {
            this.loans = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
      loadMembers () {
        api
          .get('admin/member/list', null)
          .then((response) => {
            this.members = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
